<!-- <div class="profile-card">
    <div class="flex-btw top">
        <div class="flex-btw">
            <div class="profile-circle" (click)="photo.click()">
                <img [src]="picPreview" *ngIf="picPreview && !picLoading" width="100%" height="100%" alt="" class="avatar-1">
                <mat-icon *ngIf="!picPreview && !picLoading">camera_alt</mat-icon>

                <div class="appLoader" *ngIf="picLoading">
                    <img class = "loaderImg" src="assets/images/Infinity-1.8s-200px.svg" alt="">
                </div>
                <input type="file" hidden #photo id="photo" (change)="uploadImage($event)" accept="image/*">
            </div>

            <div style="margin-left: 15px;">
                <div class="form-subtitle" >
                    Upload a New Photo
                </div>

                <div style="font-size: 12px;">
                    <sup>*</sup> Image should not be more than 5mb.
                </div>
            </div>
        </div>

        <div style="width: 18%;">
            <button mat-flat-button class="update" (click)="photo.click()">Update</button>
        </div>
      
    </div>
</div> -->

<div class="info-card">
    <div class="form-title">User Details</div> 

   <div class="flex-btw mt-3 text-box">
        <div class="split-el">
            <div class="field-label">Full Name</div>
            <div>
                {{userDetails.fullname}}
            </div>
        </div>

        <div class="split-el">
            <div class="field-label">Email Address</div>
            <div>
                {{userDetails.contactEmail}}
            </div>
        </div>
   </div>

   <!-- <div class="flex-btw mt-3 text-box">
        <div class="split-el">
            <div class="field-label">Designation</div>
            <div>
                {{userDetails.designation}}
            </div>
        </div>

        <div class="split-el">
            <div class="field-label">Category</div>
            <div>
                {{userDetails.category}}
            </div>
        </div>
    </div> -->
    <div class="flex-btw mt-3 text-box">
        <div class="split-el">
            <div class="field-label">Role type</div>
            <div>
                {{userDetails.roletype}}
            </div>
        </div>

        <div class="split-el">
            <div class="field-label">Phone Number</div>
            <div>
                {{userDetails.contactMobile}}
            </div>
        </div>
    </div>
    <div class="flex-btw mt-3 text-box" *ngIf="userDetails.designation != null">
        <div class="split-el">
            <div class="field-label">Designation</div>
            <div>
                {{userDetails.designation}}
            </div>
        </div>

        <!-- <div class="split-el">
            <div class="field-label">Phone Number</div>
            <div>
                {{userDetails.contactMobile}}
            </div>
        </div> -->
    </div>

    <div *ngIf="userDetails.supervisorid != null">
        <div class="form-title" style="margin-top: 20px; font-size: 20px;">Supervisor Details</div> 
        <div class="flex-btw mt-3 text-box">
             <div class="split-el">
                 <div class="field-label">Supervisor</div>
                 <div>
                     {{userDetails.supervisorid?.name}}
                 </div>
             </div>
             <div class="split-el">
                 <div class="field-label">Supervisor Email</div>
                 <div>
                     {{userDetails.supervisorid?.email}}
                 </div>
             </div>
     
             
         </div>
    </div>
   

    

    

   <!-- <div class="mt-3">
        <div class="field-label">Address</div>
        <div>
            <mat-form-field class="custom-form-field" floatLabel="never" appearance="outline">
                <textarea type="text" matInput placeholder="Enter Address"></textarea>
            </mat-form-field>
        </div>
    </div> -->

</div>